import { PAGE_TYPE, ROLE_TYPE } from "@supplier/meta";
import Layout from "@/views/layouts/index.vue";
import contractRouters from "@/routers/warehouseManagement/contractManagement";
import storageRouter from "@/routers/warehouseManagement/storage";
import { UserStore } from "@/stores/user";
import { hasWarehouseManagementSupervision } from "@/utils/permission";
import { AccountStore, AccountType } from "@/stores/account";

export const warehouseManagementRouters = [
    {
        path: "/warehouseManagementCompany",
        name: "WarehouseManagementCompany",
        component: Layout,
        redirect: "/warehouseManagementCompany/warehouseContract",
        meta: {
            title: "仓储管理",
            icon: "icon-a-cangchu1",
            hidden: ({ userStore, accountStore }: { userStore: UserStore; accountStore: AccountStore }) => {
                let roles = userStore.userInfo.proxyAccount?.roles;
                // 关联企业是跟随主账号的角色权限
                if (accountStore.accountType === AccountType.ASSOCIATED) {
                    roles = userStore.userInfo.customer?.roles;
                }
                // 进销存管理和仓储业务根据企业身份展示，拥有采购客户身份才展示进销存管理，拥有仓储管客户身份才展示仓储管理。
                return (
                    !roles?.includes(ROLE_TYPE.WAREHOUSE_MANAGE_CUSTOMER.code) ||
                    (accountStore.isSubAccount && !hasWarehouseManagementSupervision(userStore.userInfo.permissions))
                );
            }
        },
        children: [
            ...contractRouters,
            ...storageRouter,
            {
                path: "/StoreStatementStatistics/stock",
                name: "StoreManagementStatement",
                meta: {
                    title: "库存报表"
                },
                children: [
                    {
                        path: "detailed",
                        name: "WarehouseManagementStockDetailed",
                        component: () =>
                            import("@/views/pages/warehouseManagement/storageManagement/stockStatement/detailed/index.vue"),
                        meta: {
                            title: "库存明细",
                            isNotShowHeader: true,
                            pageType: PAGE_TYPE.LIST.code,
                            keepAlive: true
                        }
                    },
                    {
                        path: "summary",
                        name: "WarehouseManagementStockSummary",
                        component: () =>
                            import("@/views/pages/warehouseManagement/storageManagement/stockStatement/summary/index.vue"),
                        meta: {
                            title: "库存汇总",
                            isNotShowHeader: true,
                            pageType: PAGE_TYPE.LIST.code,
                            keepAlive: true
                        }
                    }
                ]
            }
        ]
    }
];
